// extracted by mini-css-extract-plugin
export default {"errorMessage":"errorform_errorMessage__KxhfL","red":"errorform_red__M8NSJ"};